<template>
    <auth-layout>
        <div class="w-full md:w-1/2 flex flex-col" :class="'epic-' + moduleStateLink">
            <div class="flex flex-col justify-center md:justify-start my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-32">
                <span class="text-center text-5xl md:text-2xl lg:text-4xl xl:text-6xl font-bold" data-cy="form-header">
                    <template v-if="isEpicvaultEnabled">
                        <img
                            class="inline-block h-12 md:h-6 lg:h-8 xl:h-12"
                            :src="'/images/icon-epic-vault.png'"
                            alt="logo"
                        />
                        <span class="text-black align-bottom">Epic</span
                        ><span class="text-default-blue align-bottom">Vault</span>
                    </template>
                    <template v-else>
                        <img class="inline-block h-12 md:h-6 lg:h-8 xl:h-12" :src="'/images/icon.png'" alt="logo" />
                        <span class="text-black align-bottom">Claims</span
                        ><span class="text-default-purple align-bottom">Vault</span>
                    </template>
                </span>

                <div>
                    <template v-if="tfa_process == 0">
                        <tfa-step-1 :tfa_enforced="true" :tfa_processing="tfa_processing" @chooseTFA="chooseTFA" />
                    </template>
                    <template v-if="tfa_process == 1">
                        <tfa-step-2
                            :tfa_enforced="true"
                            :tfa_option="tfa_option"
                            :tfa_qrcode_url="tfa_qrcode_url"
                            :tfa_processing="tfa_processing"
                            @goBackTFA="goBackTFA"
                            @submitTFAOption="submitTFAOption"
                        />
                    </template>
                    <template v-if="tfa_process == 2">
                        <tfa-step-3
                            :tfa_enforced="true"
                            :tfa_recovery_codes="tfa_recovery_codes"
                            :tfa_processing="tfa_processing"
                            @downloadRecoveryCodes="downloadRecoveryCodes"
                            @completeTFA="completeTFA"
                        />
                    </template>
                    <template v-if="tfa_process == 3">
                        <tfa-step-4 @cancelTFA="reloadTFA" />
                    </template>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue';
import TfaStep1 from '@/components/tfa/Step1.vue';
import TfaStep2 from '@/components/tfa/Step2.vue';
import TfaStep3 from '@/components/tfa/Step3.vue';
import TfaStep4 from '@/components/tfa/Step4.vue';

import store from '@/store';
import FileManager from '@/utils/file.js';

export default {
    components: {
        AuthLayout,
        TfaStep1,
        TfaStep2,
        TfaStep3,
        TfaStep4,
    },
    data() {
        return {
            tfa_processing: false,
            tfa_process: 0,
            tfa_option: 'app',
            tfa_qrcode_url: '',
            tfa_code: '',
            tfa_recovery_codes: [],
        };
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled;
        },
        moduleStateLink() {
            return this.isEpicvaultEnabled ? 'default' : 'claim';
        },
    },
    methods: {
        chooseTFA(tfa_option) {
            this.tfa_processing = true;
            this.tfa_option = tfa_option;

            switch (this.tfa_option) {
                case 'app':
                    this.$http
                        .post('/api/tfa/generate/url')
                        .then((response) => {
                            if (response.data.status == 'success') {
                                this.tfa_process = 1;
                                this.tfa_qrcode_url = response.data.url;
                            } else {
                                this.$notification.error({
                                    message: this.$t('user.notifications.error.tfa_generate_qrcode'),
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVSTFAQR02' }),
                            });
                        })
                        .finally(() => {
                            this.tfa_processing = false;
                        });
                    break;
                case 'email':
                    this.$http
                        .post('/api/tfa/generate/email')
                        .then((response) => {
                            if (response.data.status == 'success') {
                                this.tfa_process = 1;
                            } else {
                                this.$notification.error({
                                    message: this.$t('user.notifications.error.tfa_generate_email'),
                                });
                            }
                        })
                        .catch((error) => {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVSTFAE02' }),
                            });
                        })
                        .finally(() => {
                            this.tfa_processing = false;
                        });
                    break;
            }
        },
        goBackTFA() {
            this.tfa_process = this.tfa_process - 1;
        },
        submitTFAOption(tfa_code) {
            this.tfa_code = tfa_code;

            if (this.tfa_code == '') {
                this.$notification.error({
                    message: this.$t('user.notifications.error.tfa_code_required'),
                });
                return false;
            }

            this.tfa_processing = true;

            switch (this.tfa_option) {
                case 'app':
                    this.$http
                        .post('/api/tfa/verify/url', { code: this.tfa_code })
                        .then((response) => {
                            if (response.data.valid) {
                                this.tfa_code = '';
                                this.tfa_recovery_codes = response.data.recovery_codes;
                                this.tfa_process = 2;
                            } else {
                                this.$notification.error({
                                    message: this.$t('user.notifications.error.tfa_verify_code'),
                                });
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 403) {
                                this.$notification.error({
                                    message: this.$t('globals.global.notifications.error.403_mod'),
                                });
                            } else {
                                this.$notification.error({
                                    message: this.$t('globals.global.notifications.error.any', { code: 'CVSTFAVU02' }),
                                });
                            }
                        })
                        .finally(() => {
                            this.tfa_processing = false;
                        });
                    break;
                case 'email':
                    this.$http
                        .post('/api/tfa/verify/email', { code: this.tfa_code })
                        .then((response) => {
                            if (response.data.valid) {
                                this.tfa_code = '';
                                this.tfa_recovery_codes = response.data.recovery_codes;
                                this.tfa_process = 2;
                            } else {
                                this.$notification.error({
                                    message: this.$t('user.notifications.error.tfa_verify_code'),
                                });
                            }
                        })
                        .catch((error) => {
                            if (error.response.status == 403) {
                                this.$notification.error({
                                    message: this.$t('globals.global.notifications.error.403_mod'),
                                });
                            } else {
                                this.$notification.error({
                                    message: this.$t('globals.global.notifications.error.any', { code: 'CVSTFAVE02' }),
                                });
                            }
                        })
                        .finally(() => {
                            this.tfa_processing = false;
                        });
                    break;
            }
        },
        downloadRecoveryCodes() {
            this.$http
                .post('/api/tfa/download-codes')
                .then((response) => {
                    if (response.headers['content-type'] == 'text/html; charset=UTF-8') {
                        FileManager.download(response);
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVSTFADC02' }),
                    });
                });
        },
        completeTFA() {
            this.tfa_processing = true;

            this.$http
                .post('/api/tfa/enable', { type: this.tfa_option })
                .then((response) => {
                    if (response.data.status == 'success') {
                        store.dispatch('user/updateTFAProcessed', 1);
                        store.dispatch('user/updateTFA', { tfa_type: this.tfa_option, is_tfa_enabled: 1 });
                        this.tfa_process = 3;
                    } else {
                        this.$notification.error({
                            message: this.$t('user.notifications.error.tfa_enable'),
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVSTFAC01' }),
                        });
                    }
                })
                .finally(() => {
                    this.tfa_processing = false;
                });
        },
        reloadTFA() {
            this.$router.push({ name: 'home' });
        },
    },
};
</script>
